import type { TranslationMessages } from './types';

export const version: TranslationMessages = {
  update: {
    title: 'New Version Available',
    message:
      'A new version of the application is available. Please refresh to get the latest features and improvements.',
    current: 'Current Version',
    new: 'New Version',
    refresh: 'Refresh Now',
    refreshing: 'Refreshing...',
    delay: 'Remind Me Later',
    auto_refresh: 'Auto-refreshing in {{countdown}} seconds...',
  },
};
